import { Currency } from '@/core/currency/interfaces';

const BGN: Currency = {
    name: 'Bulgarian Lev',
    demonym: 'Bulgarian',
    majorSingle: 'Lev',
    majorPlural: 'Leva',
    codeNumeric: '975',
    symbol: 'лв.',
    symbolNative: 'лв.',
    minorSingle: 'Stotinka',
    minorPlural: 'Stotinki',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BGN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BGN;
